<ion-header class="ion-no-border">
  <ion-toolbar color="transparent">
    <ion-buttons slot="primary">
      <ion-button (click)="closeModal()">
        <ion-icon slot="icon-only" src="assets/header/Icon Close_White.svg"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
